// Define a persona skills class
class Skills {
  category: string;
  skills: string[];
  constructor(category: string, skills: string[]) {
    this.category = category;
    this.skills = skills;
  }
}

export default Skills;
